module.exports = __webpack_public_path__ + "img/auditReview_a.6631a69a.svg";